import {
    LOAD_TOWCOMPANYDRIVER_DATA,
    DELETE_A_TOWCOMPANYDRIVER,
    SAVE_A_TOWCOMPANYDRIVER,
    UPDATE_A_TOWCOMPANYDRIVER,
    CLEAR_A_TOWCOMPANYDRIVER_ERROR_MESSAGE
} from './actions';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE} from "../towjob/actions";

const initialState = {
  towcompanydriversArray:[],
    deleteTowCompanyDriverResp:{},
    errorCMsg:{},
    saveTowCompanyDriverResp:{},
    updateTowCompanyDriverResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_TOWCOMPANYDRIVER_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_TOWCOMPANYDRIVER_DATA:
          return Object.assign({}, state, {
              towcompanydriversArray: action.towCompanyDriversData
          });
          case DELETE_A_TOWCOMPANYDRIVER:
          return Object.assign({}, state, {
              deleteTowCompanyDriverResp: action.deleteTowCompanyDriverResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_TOWCOMPANYDRIVER:
          return Object.assign({}, state, {
              saveTowCompanyDriverResp: action.saveTowCompanyDriverResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_TOWCOMPANYDRIVER:
          return Object.assign({}, state, {
              updateTowCompanyDriverResp: action.updateTowCompanyDriverResponse,
              errorCMsg: action.errorMsg
          });

    default:
      return state;
  }
}
